import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocale, SUPPORTED_LOCALES } from "../contexts/LocaleContext";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title?: string;
  description?: string;
  canonicalPath?: string;
  lang?: string;
}

export default function SEO({ title, description, canonicalPath }: SEOProps) {
  const { locale } = useLocale();
  const location = useLocation();
  
  // Base site URL (update this to your production domain)
  const siteUrl = "https://invoitio.com";
  
  // Current relative path without locale prefix
  const currentPath = location.pathname;
  const pathParts = currentPath.split("/");
  const isLocalePath = SUPPORTED_LOCALES.includes(pathParts[1] as any);
  const cleanPath = isLocalePath ? "/" + pathParts.slice(2).join("/") : currentPath;
  const finalCleanPath = cleanPath === "//" ? "/" : cleanPath;

  const baseLocalePath = locale === 'cs' ? '' : '/' + locale;
  const pathPart = finalCleanPath === '/' ? (locale === 'cs' ? '/' : '') : finalCleanPath;
  const fullCanonicalUrl = `${siteUrl}${baseLocalePath}${pathPart}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Hreflang Tags */}
      <link rel="alternate" href={`${siteUrl}${finalCleanPath === '/' ? '/' : finalCleanPath}`} hrefLang="cs" />
      <link rel="alternate" href={`${siteUrl}/en${finalCleanPath === '/' ? '' : finalCleanPath}`} hrefLang="en" />
      <link rel="alternate" href={`${siteUrl}/ru${finalCleanPath === '/' ? '' : finalCleanPath}`} hrefLang="ru" />
      <link rel="alternate" href={`${siteUrl}${finalCleanPath === '/' ? '/' : finalCleanPath}`} hrefLang="x-default" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullCanonicalUrl} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={`${siteUrl}/logo512.png`} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonicalUrl} />
      {title && <meta property="twitter:title" content={title} />}
      {description && <meta property="twitter:description" content={description} />}
      <meta property="twitter:image" content={`${siteUrl}/logo512.png`} />
    </Helmet>
  );
}

